import styled from 'styled-components';
import { IconStyledProps } from './Icon.typed';

export const Wrapper = styled.span<IconStyledProps>`
  display: inline-block;
  vertical-align: middle;
  color: ${({ color }) => color ?? 'inherit'};

  svg {
    display: block;
    width: ${({ theme, size }) => theme.components.icon.sizes[size]};
    height: ${({ theme, size }) => theme.components.icon.sizes[size]};
    color: inherit;
  }
`;
